// Landing Page Interactive Scripts — shopify-store-architect scaffold
//
// Runs on initial DOMContentLoaded AND on `shopify:section:load`, which
// Shopify's Theme Customizer fires when a merchant adds/reorders a section
// via AJAX without a full page reload. Every init function guards already-
// initialized elements with a data-cro-init flag so re-running on
// shopify:section:load never double-attaches listeners.

function switchMainImage(src, thumbEl) {
  const mainImg = document.getElementById('MainProductImage')
  if (mainImg) mainImg.src = src

  document.querySelectorAll('.thumb-item').forEach((el) => el.classList.remove('active'))
  if (thumbEl) thumbEl.classList.add('active')
}

function scrollToBuyBox() {
  const buyBox = document.getElementById('AddToCartForm')
  if (buyBox) {
    buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

function initCroInteractions() {
  initFaqAccordions()
  initStickyAtc()
  initExitIntent()
  initBeforeAfterSliders()
  initAnnouncementCountdowns()
  initBundleSelectors()
}

// --- Variant-driven bundle selector -------------------------------------
// Each .bundle-card carries data-variant-id / data-price-formatted /
// data-compare-formatted / data-discount-percent (see snippets/quantity-breaks.liquid).
// Selecting a card updates the REAL variant submitted on add-to-cart
// (#SelectedVariantId) and the displayed price — this is not decorative.
function initBundleSelectors() {
  const cards = document.querySelectorAll('.bundle-card:not([data-cro-init])')
  cards.forEach((card) => {
    card.dataset.croInit = '1'
    card.addEventListener('click', () => selectBundle(card))
  })

  // Sync the sticky bar (and any other mirrored price elements) with
  // whichever bundle card is already selected on page load, since the
  // sticky section renders server-side with its own default variant.
  const activeCard = document.querySelector('.bundle-card.active')
  if (activeCard) selectBundle(activeCard)
}

function selectBundle(cardEl) {
  const wrapper = cardEl.closest('.landing-buybox') || document
  wrapper.querySelectorAll('.bundle-card').forEach((card) => card.classList.remove('active'))
  cardEl.classList.add('active')

  const radio = cardEl.querySelector('input[type="radio"]')
  if (radio) radio.checked = true

  const variantId = cardEl.dataset.variantId
  const variantInput = wrapper.querySelector('#SelectedVariantId')
  if (variantId && variantInput) variantInput.value = variantId

  const priceEl = wrapper.querySelector('#ProductPrice')
  if (priceEl && cardEl.dataset.priceFormatted) priceEl.textContent = cardEl.dataset.priceFormatted

  const stickyPriceEl = document.getElementById('StickyProductPrice')
  if (stickyPriceEl && cardEl.dataset.priceFormatted) stickyPriceEl.textContent = cardEl.dataset.priceFormatted

  const compareEl = wrapper.querySelector('#ComparePrice')
  const discountEl = wrapper.querySelector('#DiscountBadge')
  if (cardEl.dataset.compareFormatted) {
    if (compareEl) {
      compareEl.textContent = cardEl.dataset.compareFormatted
      compareEl.style.display = ''
    }
    if (discountEl) {
      discountEl.textContent = '%' + cardEl.dataset.discountPercent + ' İNDİRİM'
      discountEl.style.display = ''
    }
  } else {
    if (compareEl) compareEl.style.display = 'none'
    if (discountEl) discountEl.style.display = 'none'
  }
}

function initFaqAccordions() {
  document.querySelectorAll('.faq-question:not([data-cro-init])').forEach((btn) => {
    btn.dataset.croInit = '1'
    btn.addEventListener('click', () => {
      const item = btn.parentElement
      item.classList.toggle('active')
      const icon = btn.querySelector('.icon')
      if (icon) {
        icon.textContent = item.classList.contains('active') ? '-' : '+'
      }
    })
  })
}

function initStickyAtc() {
  const heroButton = document.getElementById('HeroATCButton')
  const stickyBar = document.getElementById('StickyATCBar')
  if (!heroButton || !stickyBar || stickyBar.dataset.croInit) return

  stickyBar.dataset.croInit = '1'
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting)
      })
    },
    { threshold: 0.1 }
  )

  observer.observe(heroButton)
}

// --- Exit-intent modal -----------------------------------------------
// Fires once per browser session when the cursor leaves near the top of
// the viewport (classic "about to close the tab" signal on desktop).
function initExitIntent() {
  const overlay = document.getElementById('CroExitModal')
  if (!overlay || overlay.dataset.croInit) return
  overlay.dataset.croInit = '1'

  document.addEventListener('mouseleave', (e) => {
    if (e.clientY > 20) return
    if (sessionStorage.getItem('croExitIntentShown')) return

    overlay.classList.add('visible')
    sessionStorage.setItem('croExitIntentShown', '1')
  })

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('visible')
  })
}

// --- Before/After interactive slider ----------------------------------
// Works with mouse drag and touch drag. Expects markup:
// .cro-ba-slider > img (before, full-width) + .cro-ba-after-wrap > img (after)
// + .cro-ba-handle, all inside the same .cro-ba-slider container.
function initBeforeAfterSliders() {
  document.querySelectorAll('.cro-ba-slider:not([data-cro-init])').forEach((slider) => {
    const afterWrap = slider.querySelector('.cro-ba-after-wrap')
    const handle = slider.querySelector('.cro-ba-handle')
    if (!afterWrap || !handle) return
    slider.dataset.croInit = '1'

    let dragging = false

    const setPosition = (clientX) => {
      const rect = slider.getBoundingClientRect()
      let percent = ((clientX - rect.left) / rect.width) * 100
      percent = Math.min(100, Math.max(0, percent))

      afterWrap.style.width = percent + '%'
      afterWrap.style.setProperty('--cro-ba-img-width', rect.width + 'px')
      handle.style.left = percent + '%'
    }

    const onMove = (e) => {
      if (!dragging) return
      const clientX = e.touches ? e.touches[0].clientX : e.clientX
      setPosition(clientX)
    }

    const stopDrag = () => {
      dragging = false
    }

    handle.addEventListener('mousedown', () => (dragging = true))
    handle.addEventListener('touchstart', () => (dragging = true), { passive: true })

    window.addEventListener('mousemove', onMove)
    window.addEventListener('touchmove', onMove, { passive: true })
    window.addEventListener('mouseup', stopDrag)
    window.addEventListener('touchend', stopDrag)

    slider.addEventListener('click', (e) => setPosition(e.clientX))
  })
}

// --- Announcement bar countdown ---------------------------------------
// Counts down to a real, merchant-set end date/time. Never loops or resets
// once it hits zero — it just switches to the configured end-state message.
function initAnnouncementCountdowns() {
  document.querySelectorAll('[data-countdown-end]:not([data-cro-init])').forEach((bar) => {
    bar.dataset.croInit = '1'
    const timerEl = bar.querySelector('#CroCountdownTimer')
    if (!timerEl) return

    const endTime = new Date(bar.dataset.countdownEnd).getTime()
    if (Number.isNaN(endTime)) return

    const tick = () => {
      const remaining = endTime - Date.now()
      if (remaining <= 0) {
        timerEl.textContent = timerEl.dataset.endText || ''
        clearInterval(intervalId)
        return
      }
      const d = Math.floor(remaining / 86400000)
      const h = Math.floor((remaining % 86400000) / 3600000)
      const m = Math.floor((remaining % 3600000) / 60000)
      const s = Math.floor((remaining % 60000) / 1000)
      const parts = d > 0 ? [d + 'g', h + 's', m + 'd', s + 'sn'] : [h + 's', m + 'd', s + 'sn']
      timerEl.textContent = parts.join(' ')
    }

    tick()
    const intervalId = setInterval(tick, 1000)
  })
}

function dismissAnnouncementBar() {
  const bar = document.getElementById('CroAnnouncementBar')
  if (bar) bar.classList.add('dismissed')
}

document.addEventListener('DOMContentLoaded', initCroInteractions)
document.addEventListener('shopify:section:load', initCroInteractions)
